import {Button} from '@wandb/components';
import * as React from 'react';

import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';

export const RunIssuesButton = () => {
  const {toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  return (
    <Button
      label="Issues"
      onClick={() => {
        toggleWorkspaceDrawer('run-issues');
      }}
      variant="secondary"></Button>
  );
};
